var exports = {
  "zr": "GameOverlayHost.module__root___UWVvYz",
  "sQ": "GameOverlayHost.module__bottom___UWVvYz",
  "zY": "GameOverlayHost.module__speaking___UWVvYz",
  "eh": "GameOverlayHost.module__room___UWVvYz",
  "nM": "GameOverlayHost.module__row___UWVvYz",
  "my": "GameOverlayHost.module__avatar___UWVvYz",
  "su": "GameOverlayHost.module__avatarSpeaking___UWVvYz",
  "fs": "GameOverlayHost.module__micBadge___UWVvYz",
  "_2": "GameOverlayHost.module__micBadgeOff___UWVvYz",
  "Vo": "GameOverlayHost.module__micIcon___UWVvYz",
  "UU": "GameOverlayHost.module__name___UWVvYz",
  "ju": "GameOverlayHost.module__overflow___UWVvYz",
};

module.exports = exports;
